export function filterStatus (flg) {
  if (flg) return 'フィルタリング中'
  return 'フィルタリング設定'
}
